<atn-display-value
  [label]="labelSg()"
  [type]="typeSg()"
  [value]="valueSg()"
  [required]="requiredSg()"
  (valueChange)="valueChange.emit($event)"
/>
